import {StorageService} from "./StorageService";
import {ESendStatus, ISendQueueEntry} from "./ISendQueueEntry";
import {TimeQueueItem} from "./TimeQueueItem";
import * as angular from 'angular';
import {ProxyContainer} from '../Data/Data';

export class EntryQueueService {

  static $inject = ["$timeout", StorageService.serviceId, "$proxy"];
  static serviceId = "entryQueue";

  sendQueueMaxChunkSize = 50;
  sendInterval = 60000;
  isSending = false;
  sendQueue: ISendQueueEntry[];

  constructor(
    private $timeout: angular.ITimeoutService,
    private storageService: StorageService,
    private $proxy: ProxyContainer
  ) {
    this.init();
  }

  init() {
    this.sendQueue = this.storageService.getEntryQueue() || [];

    angular.forEach(this.sendQueue, (entry) => {
      entry.status = ESendStatus.Pending;
    });
    this.send();
  }

  enqueue(data: TimeQueueItem) {
    console.log('enqueuing stamp: ', data);
    this.sendQueue.push({ data: data, status: ESendStatus.Pending });
    this.storageService.setEntryQueue(this.sendQueue);
    if (!this.isSending)
      this.send();
    else {
      this.sendAfterTimeout();
    }
  }

  private sendAfterTimeout() {
    this.$timeout(() => this.send(), this.sendInterval);
  }

  private send() {
    const entriesToSend = this.getTimeEntriesToSend();
    if (this.isSending || entriesToSend.length === 0) {
      return;
    }
    this.isSending = true;
    this.$proxy.TimeStamp.submitStamps(entriesToSend).then(() => {
      this.success();
    }, err => {
      console.log(err);
      this.fail();
    });
  }

  private getTimeEntriesToSend = () => {
    const entriesToSend = [];
    angular.forEach(this.sendQueue, (entry) => {
      const chunkLimitReached = entriesToSend.length >= this.sendQueueMaxChunkSize;
      if (entry.status === ESendStatus.Pending && !chunkLimitReached) {
        entry.status = ESendStatus.Sending;
        entriesToSend.push(TimeQueueItem.toTimeEntryModel(entry.data));
      }
    });
    return entriesToSend;
  };

  private fail() {
    angular.forEach(this.sendQueue, (entry) => {
      if (entry.status === ESendStatus.Sending) {
        entry.status = ESendStatus.Pending;
      }
    });
    this.storageService.setEntryQueue(this.sendQueue);
    this.isSending = false;
    this.$timeout(() => this.send(), 10000);
  }

  private success(){

    this.sendQueue = this.sendQueue.filter(entry => entry.status !== ESendStatus.Sending);

    this.storageService.setEntryQueue(this.sendQueue);
    this.isSending = false;
    if (this.sendQueue.length === 0) {
      this.send();
    }
  }
}
